/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

// URL-based for Anvilor servers, so fine to keep this in source control (no need
//  to hide it...?).

export const APP_GOOGLE_MAPS_API_KEY = "AIzaSyBXmUk9Al3TMbJWUsDr33BHXofa53cbKjE";
export const APP_GRECAPTCHA_SITE_KEY = "6LdyiaYpAAAAAC8iXgwZ-O6hBqjumbLRxvgRPCPf";
